import {
  filterPermittedActionsWithDividers,
  parseActionsOnValidDivider,
} from '../../../../../../utils/massActions'
import { getSelectDropdownListDividerOption } from '../../../../../Select'
import { REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_HEADER_ACTION } from '../../../RequestProfileTabEmails.constants'

import DeleteIcon from '../../../../../../icons/delete.svg'
import EmailUnreadIcon from '../../../../../../icons/email-unread.svg'
import ExportIcon from '../../../../../../icons/export.svg'
import PrintIcon from '../../../../../../icons/print.svg'
import ServiceRequestIcon from '../../../../../../icons/service-request.svg'
import StarEmptyIcon from '../../../../../../icons/star.svg'
import StarFilledIcon from '../../../../../../icons/star-filled.svg'

export function getHasFiles(messages) {
  return messages?.some(message => message.files?.length > 0)
}

export function getIconBarActions({
  directoryId,
  hasFiles,
  permissions,
  starred,
  t,
}) {
  return filterPermittedActionsWithDividers([
    {
      beforeIconProps: { Icon: starred ? StarFilledIcon : StarEmptyIcon },
      permission: permissions.can_edit_starred,
      tooltip: t(
        starred
          ? 'EmailProfile.ActionsWidgetMarkAsUnstarredTooltipKey'
          : 'EmailProfile.ActionsWidgetMarkAsStarredTooltipKey'
      ),
      value:
        REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_HEADER_ACTION.ToggleStarred,
    },
    {
      beforeIconProps: { Icon: EmailUnreadIcon },
      permission: permissions.can_edit_unread_status,
      tooltip: t('EmailProfile.ActionsWidgetMarkAsUnreadTooltipKey'),
      value: REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_HEADER_ACTION.MarkAsUnread,
    },
    {
      beforeIconProps: { Icon: ServiceRequestIcon },
      permission: permissions.can_move_to_another_request,
      tooltip: t('RequestProfile.TabEmailsMoveToServiceRequestActionKey'),
      value:
        REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_HEADER_ACTION.MoveToAnotherServiceRequest,
    },
    {
      beforeIconProps: { Icon: PrintIcon },
      permission: true,
      tooltip: t('EmailProfile.ActionsWidgetPrintTooltipKey'),
      value: REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_HEADER_ACTION.Print,
    },
    {
      beforeIconProps: { Icon: ExportIcon },
      permission: Boolean(directoryId) && hasFiles,
      tooltip: t('EmailProfile.ActionsWidgetDownloadAllFilesTooltipKey'),
      value:
        REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_HEADER_ACTION.DownloadFiles,
    },
    {
      beforeIconProps: { Icon: DeleteIcon },
      permission: permissions.can_delete,
      tooltip: t('RequestProfile.TabEmailsDeleteActionKey'),
      value: REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_HEADER_ACTION.Delete,
    },
  ])
}

export function getMenuActions({
  directoryId,
  hasFiles,
  permissions,
  starred,
  t,
}) {
  return parseActionsOnValidDivider(
    filterPermittedActionsWithDividers([
      {
        label: t('Emails.MarkAsUnreadActionOptionKey'),
        permission: permissions.can_edit_unread_status,
        value:
          REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_HEADER_ACTION.MarkAsUnread,
      },
      {
        label: t(
          starred
            ? 'Emails.MarkAsUnstarredActionOptionKey'
            : 'Emails.MarkAsStarredActionOptionKey'
        ),
        permission: permissions.can_edit_starred,
        value:
          REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_HEADER_ACTION.ToggleStarred,
      },
      {
        label: t('RequestProfile.TabEmailsMoveToTabActionKey'),
        permission: permissions.can_edit_audience,
        value: REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_HEADER_ACTION.MoveToTab,
      },
      {
        label: t('RequestProfile.TabEmailsMoveToServiceRequestActionKey'),
        permission: permissions.can_move_to_another_request,
        value:
          REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_HEADER_ACTION.MoveToAnotherServiceRequest,
      },
      {
        label: t('RequestProfile.TabEmailsAttachToActivityActionKey'),
        permission: permissions.can_attach_to_activity,
        value:
          REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_HEADER_ACTION.AttachToActivity,
      },
      {
        label: t('RequestProfile.TabEmailsAddNoteActionKey'),
        permission: permissions.can_edit_note,
        value: REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_HEADER_ACTION.AddNote,
      },
      {
        label: t('Emails.PrintActionOptionKey'),
        permission: true,
        value: REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_HEADER_ACTION.Print,
      },
      {
        label: t('RequestProfile.TabEmailsDownloadAllFilesActionKey'),
        permission: Boolean(directoryId) && hasFiles,
        value:
          REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_HEADER_ACTION.DownloadFiles,
      },
      getSelectDropdownListDividerOption(),
      {
        label: t('RequestProfile.TabEmailsDeleteActionKey'),
        permission: permissions.can_delete,
        value: REQUEST_PROFILE_TAB_EMAILS_THREAD_MODAL_HEADER_ACTION.Delete,
      },
    ])
  )
}
